import { EducationReduxActionTypes } from "./Education.actions";

const initialState = {
  form: {},
  education: [
    {
      college: "",
      country_id: "",
      degree: "",
      level: "",
      start_year: "",
      start_month: "",
      end_year: "",
      end_month: "",
      is_current: false,
    },
  ],
};
function EducationReducer(state = initialState, action) {
  const { type = "", payload = null } = { ...action };
  switch (type) {
    case EducationReduxActionTypes.RESET_STATE_DATA:
      return { ...initialState };
    case EducationReduxActionTypes.UPDATE_FORM_INSTANCE:
      return {
        ...state,
        form: payload.form,
      };
    default:
      return state;
  }
}

export default EducationReducer;
